module.exports = __webpack_public_path__ + "media/solo-action.2be3bd34.mp4";